package com.milta.core.localization.translations.fr

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Nouvelle livraison",
    manualDeliverySubtitle = "Ajoutez une livraison à la tournée",
    recipientNameLabel = "Nom du destinataire",
    addressLabel = "Adresse",
    phoneNumberLabel = "Téléphone",
    deliveryTimeLimitLabel = "Heure limite",
    optionalSuffix = "(facultatif)",
    submitButton = "Ajouter la livraison",
    saveEditedDeliveryButton = "Enregistrer la modification",
    deliveryCreated = "Livraison ajoutée",
    errorRecipientNameRequired = "Le nom du destinataire est requis",
    errorRecipientNameTooLong = "Le nom est trop long (150 caractères max)",
    errorAddressRequired = "L'adresse est requise",
    errorAddressTooLong = "L'adresse est trop longue (255 caractères max)",
    errorPhoneTooLong = "Le téléphone est trop long (20 caractères max)",
    errorDuplicateDelivery = "Cette livraison est déjà dans la liste (même destinataire et adresse)",
    errorRouteNotFound = "Tournée introuvable",
    errorForbidden = "Vous n'êtes pas autorisé à modifier cette tournée",
    errorValidation = "Veuillez vérifier les champs saisis",
    errorGeneric = "Une erreur est survenue. Réessayez.",
    errorRouteNotInProgress = "Cette tournée n'est plus en cours. Impossible d'ajouter une livraison.",
    unknownRecipientLabel = "Non connu",
    driverHomeTitle = "Ma tournée",
    driverModeBadge = "Mode Livreur",
    routeStatusScheduled = "Planifiée",
    routeStatusInProgress = "En cours",
    routeStatusCompleted = "Terminée",
    stopsCountLabel = "arrêts",
    startRouteButton = "Démarrer la tournée",
    noRouteTitle = "Aucune tournée",
    noRouteSubtitle = "Aucune tournée ne vous est assignée pour le moment.",
    noRoutePastSubtitle = "Aucune tournée ne vous a été assignée pour cette date.",
    routeInProgressTitle = "Tournée en cours",
    routeCompletedTitle = "Tournée terminée",
    deliveriesSectionTitle = "Livraisons",
    addStopButton = "Ajouter un arrêt",
    errorConflict = "La tournée a déjà été démarrée ou terminée.",
    greetingPrefix = "Bonjour",
    routeOfTheDayLabel = "TOURNÉE DU JOUR",
    noOtherRouteLabel = "Aucune autre tournée planifiée",
    routeLabel = "Tournée",
    importMenuTitle = "Importer des livraisons",
    importMenuSubtitle = "Plusieurs modes combinables — choisissez une source",
    importModePhotoPaperTitle = "Photo — liste papier",
    importModePhotoPaperDesc = "Photographiez une feuille manuscrite ou imprimée",
    importModePhotoLabelTitle = "Photo — étiquette de colis",
    importModePhotoLabelDesc = "Scannez l'étiquette collée sur un colis",
    importModePdfTitle = "Importer un PDF",
    importModePdfDesc = "Bons de livraison, fichier scanné",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Votre propre format — colonnes détectées automatiquement",
    importModeManualTitle = "Saisie manuelle",
    importModeManualDesc = "Nom, adresse, téléphone, heure limite",
    createRouteTitle = "Créer une tournée",
    createRouteEmptyDrivers = "Aucun chauffeur dans votre équipe pour l'instant",
    editDeliveriesAction = "Modifier",
    moreDeliveriesLabel = "autres",
    addDeliveriesAction = "Ajouter des livraisons",
    assignToTitle = "Assigner à",
    optimizeRouteButton = "Optimiser l'itinéraire",
    createRouteButtonNoOptimize = "Créer la tournée",
    errorNoEnterprise = "Aucune entreprise associée à votre compte",
    errorDriverNotFound = "Chauffeur introuvable",
    errorNoDeliveries = "Ajoutez au moins une livraison avant d'optimiser l'itinéraire",
    errorOptimizationUnavailable = "Le service d'optimisation est temporairement indisponible.",
    errorGeocodingFailed = "Certaines adresses n'ont pas pu être localisées. Modifiez l'adresse et réessayez.",
    dispatchTitle = "Optimisation",
    optimizedSuccessTitle = "Itinéraire optimisé !",
    optimizedSuccessSubtitleSuffix = "arrêts ordonnés pour le trajet le plus court",
    stopsStatLabel = "Arrêts",
    driverAvailableStatus = "Disponible",
    sendRouteButtonPrefix = "Envoyer la tournée à",
    errorRouteAlreadyDispatched = "La tournée a déjà été envoyée.",
    stopDetailTitlePrefix = "Arrêt",
    stopStatusCurrentLabel = "En cours",
    stopStatusUpcomingLabel = "À venir",
    stopStatusDeliveredLabel = "Livré",
    stopStatusFailedLabel = "Échec",
    stopRecipientLabel = "Destinataire",
    callActionLabel = "Appeler",
    noPhoneLabel = "Téléphone non renseigné",
    packagesCountLabel = "colis",
    navigateButton = "Naviguer",
    deadlineBeforePrefix = "Avant",
    deadlinePastSuffix = "dépassée",
    validateStopAction = "Valider cet arrêt",
    teamDashboardTitle = "Tournées",
    todayDateLabel = "Aujourd'hui",
    liveBadgeLabel = "En direct",
    statRoutesLabel = "Tournées",
    statDeliveriesLabel = "Livraisons",
    statCompletedLabel = "Terminées",
    teamSectionTitle = "Équipe",
    routeStartedAtPrefix = "Démarrée à",
    routeCompletedAtPrefix = "Terminée à",
    routeNotStartedLabel = "Non démarrée",
    emptyTeamRoutesTitle = "Aucune tournée ce jour-là",
    emptyTeamRoutesSubtitle = "Aucun chauffeur de l'équipe n'a de tournée planifiée pour cette date.",
    errorInvalidDate = "Date invalide",
    routeDetailTitle = "Détail tournée",
    driverEyebrowLabel = "Chauffeur",
    failedDeliveryTag = "Échec de livraison",
    driverLoadingCheckTitle = "Vérification du chargement",
    loadingCheckInstructionText = "Vérifiez que tous les colis prévus sont bien chargés dans le véhicule avant de prendre la route.",
    expectedPackagesLabel = "colis prévus pour cette tournée",
    confirmLoadCheckboxPrefix = "J'ai bien chargé les",
    confirmLoadCheckboxSuffix = "colis prévus pour cette tournée",
    reportDiscrepancyToggleLabel = "Signaler un écart",
    discrepancyNotePlaceholder = "Ex : j'ai chargé 9 colis au lieu de 11…",
    discrepancyNoteTooLong = "Note trop longue — 500 caractères maximum.",
    undeliveredStopsSectionTitle = "Colis non pris en charge — retirer de la tournée",
    removedStopNoticePrefix = "«",
    removedStopNoticeMiddle = "» retirée de la tournée — 1 arrêt en moins",
    remainingStopsSuffix = "restants",
    confirmAndStartButton = "Confirmer et démarrer la tournée",
    loadingOnBehalfOfLabel = "Pour le compte de",
    loadingExpectedLabel = "Chargement prévu",
    loadingQuestionTitle = "Avez-vous chargé tous les colis ?",
    loadingAllLoadedPrefix = "Oui, les",
    loadingAllLoadedSuffix = "colis sont à bord",
    loadingIncompleteOption = "Chargement incomplet",
    loadingIncompleteHint = "Je retire les arrêts concernés ou je justifie",
    loadingIncompleteRemoveLabel = "Et/ou retirez les arrêts non chargés",
    slideToStartLabel = "Glissez pour démarrer",
    completeRouteButton = "Terminer la tournée",
    completeRouteDialogTitle = "Terminer la tournée ?",
    completeRouteDialogPendingCountSuffix = "livraisons n'ont pas encore été traitées",
    completeRouteDialogPendingNote = "Elles seront marquées comme non traitées.",
    completeRouteDialogBody = "Cette action est définitive : la tournée passera au statut « Terminée » et ne pourra plus être modifiée.",
    completeRouteDialogBodyAllTreated = "Toutes les livraisons ont été traitées. La tournée passera au statut « Terminée » et ne pourra plus être modifiée.",
    completeRouteDialogConfirm = "Terminer",
    routeCompletedMessage = "Tournée terminée.",
    stopStatusUntreatedLabel = "Non traité",
    errorCompleteRouteStatusConflict = "Cette tournée ne peut pas être terminée dans son état actuel.",
    errorCompleteRoutePendingStopsConflict = "Des livraisons sont encore en attente. Confirmez pour terminer quand même.",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Nombre de colis",
    newStopBadgeLabel = "NOUVEAU",
    reoptimizeResultTitle = "Nouvel itinéraire",
    reoptimizeSuccessTitle = "Itinéraire re-optimisé",
    reoptimizeSuccessSubtitleSuffix = "arrêt ajouté et repositionné pour le trajet le plus court.",
    reoptimizeFallbackTitle = "Stop ajouté, ré-optimisation indisponible",
    reoptimizeFallbackSubtitle = "Le service d'optimisation est temporairement indisponible. Le nouvel arrêt a été ajouté en fin de liste.",
    addedStatLabel = "Ajouté",
    backToRouteButton = "Retour à la tournée",
    routeBatchMultiDriverLink = "Répartir entre plusieurs chauffeurs",
    routeBatchSelectTitle = "Répartir la tournée",
    routeBatchDeliveriesReadyLabel = "livraisons prêtes à être réparties",
    routeBatchDriversSectionTitle = "Chauffeurs",
    routeBatchDriversSelectedSuffix = "chauffeurs sélectionnés",
    routeBatchOptimizeToggleTitle = "Optimiser l'itinéraire",
    routeBatchOptimizeToggleHelp = "RoutaR répartit et ordonne les stops selon la distance. Désactivé : répartition équitable simple par nombre de stops, sans calcul de trajet.",
    routeBatchSubmitButtonPrefix = "Répartir entre",
    routeBatchDriversWord = "chauffeurs",
    routeBatchOptimizationUnavailable = "Service d'optimisation temporairement indisponible. La tournée n'a pas été créée — vérifiez votre connexion et réessayez, ou désactivez « Optimiser l'itinéraire » pour une répartition simple immédiate.",
    routeBatchPreviewTitle = "Aperçu de la répartition",
    routeBatchPreviewEyebrowMiddle = "livraisons réparties entre",
    routeBatchPreviewEyebrowSuffix = "chauffeurs",
    routeBatchStopsChipSuffix = "stops",
    routeBatchDistanceLabel = "Distance",
    routeBatchDurationLabel = "Durée estimée",
    routeBatchDistanceNotCalculated = "Non calculée",
    routeBatchOptimizeDisabledBanner = "Optimisation désactivée : répartition équitable par nombre de stops, sans calcul de distance ni d'ordre de passage.",
    routeBatchReoptimizeButton = "Ré-optimiser",
    routeBatchDispatchButton = "Valider et envoyer",
    errorRouteBatchAlreadyDispatched = "Cette tournée a déjà été envoyée aux chauffeurs — impossible de la modifier.",
    routeBatchDispatchedTitle = "Tournées envoyées !",
    routeBatchDispatchedSubtitleSuffix = "chauffeurs notifiés simultanément, chacun avec sa propre tournée programmée.",
    routeBatchStatRoutesLabel = "Tournées",
    routeBatchStatDeliveriesLabel = "Livraisons",
    routeBatchStatusLabel = "Statut",
    routeBatchStatusDispatchedValue = "Envoyée",
    routeBatchSentAtLabel = "Envoyé le",
    routeBatchPerDriverTitle = "Détail par chauffeur",
    routeBatchDriverScheduledStatus = "Programmée",
    routeBatchBackToHomeButton = "Retour à l'accueil",
    errorTooManyDrivers = "Vous ne pouvez pas sélectionner plus de 50 chauffeurs à la fois.",
    errorTooManyDeliveries = "Le lot ne peut pas dépasser 500 livraisons.",
    createRouteFabLabel = "Nouvelle tournée",
    createOwnRouteButtonLabel = "Créer / Optimiser ma tournée",
    createOwnRouteTitle = "Créer ma tournée",
    createOwnRouteDeliveriesCountSuffix = "livraisons prêtes",
    stopStatusEnRouteLabel = "En route",
    yesterdayDateLabel = "Hier",
    periodPastLabel = "Passé",
    periodTomorrowLabel = "Demain",
    viewRouteButton = "Voir la tournée",
    viewButton = "Voir",
    noRouteTomorrowTitle = "Rien de prévu pour demain",
    noRouteTomorrowSubtitle = "Planifie une tournée à l'avance pour l'avoir prête dès demain matin.",
    planRouteButtonLabel = "Planifier une tournée",
    myRoutesTodayTitle = "Vos tournées d'aujourd'hui",
    myRoutesTitle = "Vos tournées",
    weekdayShortNames = listOf("Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"),
    weekdayFullNames = listOf("Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"),
    monthNames = listOf("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"),
    statRoutesTodayLabel = "Tournées aujourd'hui",
    statStopsTodayLabel = "Arrêts aujourd'hui",
    statOnTimeLabel = "À temps aujourd'hui",
    statAvgProgressLabel = "Avancement moyen",
    inProgressSectionTitle = "En cours",
    upcomingSectionTitle = "À venir",
    doneSectionTitle = "Terminées",
    seeAllLabel = "Voir tout",
    continueRouteButton = "Continuer la tournée",
    detailsLinkLabel = "Détails",
    deliveryProofTitle = "Valider la livraison",
    deliveryProofStatusSectionLabel = "Statut de la livraison",
    deliveryProofPhotoSectionLabel = "Photo justificative",
    deliveryProofPhotoHint = "Obligatoire pour valider",
    deliveryProofTakePhotoCta = "Prendre une photo",
    deliveryProofRetakePhotoCta = "Reprendre une photo",
    deliveryProofRetakeChipLabel = "Reprendre",
    deliveryProofCommentSectionLabel = "Commentaire",
    deliveryProofCommentRequiredSuffix = "obligatoire si échec",
    deliveryProofCommentPlaceholderOptional = "Optionnel — précisions sur la livraison…",
    deliveryProofCommentPlaceholderRequired = "Expliquez la raison de l'échec…",
    deliveryProofCommentRequiredError = "Un commentaire est requis en cas d'échec de livraison",
    deliveryProofSubmitButton = "Valider la livraison",
    deliveryProofErrorInvalidPhoto = "Photo illisible ou format non supporté. Reprenez la photo et réessayez.",
    deliveryProofAlreadyProcessedBanner = "Cet arrêt a déjà été traité et ne peut plus être modifié.",
    deliveryConfirmTitle = "Livraison validée",
    deliveryConfirmSuccessTitle = "Livraison confirmée",
    deliveryConfirmSuccessSubtitle = "La preuve a bien été enregistrée pour cet arrêt.",
    deliveryConfirmFailedTitle = "Échec enregistré",
    deliveryConfirmFailedSubtitle = "Le commentaire et la photo ont été transmis au gestionnaire.",
    deliveryConfirmRouteCompletedTitle = "Tournée terminée !",
    deliveryConfirmRouteCompletedSubtitle = "Tous les arrêts ont été traités.",
    deliveryConfirmValidatedAtLabel = "Validé le",
    deliveryConfirmNextStopEyebrowPrefix = "Arrêt suivant",
    deliveryConfirmGoToNextStopButton = "Aller à l'arrêt suivant",
    deliveryConfirmAllDoneMessage = "C'était le dernier arrêt de la tournée — pensez à la clôturer.",
    offlineBannerTitle = "Hors connexion",
    offlineBannerRouteSubtitle = "vos validations seront envoyées dès le retour du réseau",
    offlineBannerValidateSubtitle = "sera enregistré localement",
    offlineSyncingBannerTitle = "Synchronisation en cours",
    offlineSyncingSubtitleSuffix = "livraisons envoyées",
    offlineRetryBannerTitle = "Échec de synchronisation",
    offlineRetryBannerSubtitle = "nouvelle tentative au prochain retour réseau",
    offlineSyncSuccessToastSuffix = "livraisons synchronisées avec succès",
    offlineQueuedBadgePendingLabel = "En attente d'envoi",
    offlineQueuedBadgeSyncingLabel = "Envoi en cours",
    offlineQueuedBadgeFailedLabel = "Échec — réessai prévu",
    offlineQueuedBadgeConflictLabel = "Déjà traité ailleurs",
    offlineDismissConflictAction = "Effacer",
    offlineValidatedLocallyAtPrefix = "validé localement à",
    offlineAddStopRequiresConnectionSuffix = "(nécessite une connexion)",
    deliveryProofOfflineSubmitButton = "Enregistrer (synchro différée)",
    deliveryProofSavedLocallyTitle = "Enregistré localement",
    deliveryProofSavedLocallySubtitle = "Cette livraison sera envoyée automatiquement dès que la connexion sera rétablie.",
    routeScheduledBannerTitle = "Tournée pas encore démarrée",
    routeScheduledBannerSubtitle = "Démarrez la tournée pour pouvoir valider une livraison.",
    geocodeIssueTag = "Adresse non localisée",
    regeocodeAction = "Réessayer la géolocalisation",
    regeocodeSuccessMessage = "Adresses mises à jour",
    dashboardTitle = "Dashboard",
    viewAllAction = "Tout voir",
    deleteRouteDialogTitle = "Supprimer la tournée ?",
    deleteRouteDialogMessage = "Cette tournée sera supprimée définitivement. Cette action est irréversible.",
    errorRouteDeleteConflict = "Suppression indisponible : la tournée est en cours.",
    errorDriverHasActiveRoute = "Une autre tournée est actuellement en cours. Terminez-la avant de démarrer celle-ci.",
    dashboardLiveBadge = "En direct",
    routeBatchNoStopsTag = "Aucun arrêt",
    routeBatchNoStopsDialogTitle = "Chauffeur sans arrêt",
    routeBatchNoStopsDialogMessage = "Au moins un chauffeur n'a aucun arrêt assigné. Il recevra quand même une tournée vide s'il n'est pas retiré du lot. Envoyer quand même ?",
    ),
)
